import { useEffect, useState } from 'react';
import { Filter, floorLayoutList } from './components/Filter';
import { DisclaimerCard } from 'components/DisclaimerCard';
import { FloorDetail } from './components/FloorDetail';
import { FloorPlan } from './components/FloorPlan';
import { FloorPalette } from './components/FloorPalette';
import { ApartmentInfo } from 'components/ApartmentInfo';

import './style.scss';
// import DropdownMenu from 'components/DropdownMenu';
// import { InfoCircle } from 'assets/icons/InfoCircle';

const MatBangTangPage = () => {
  // Initialize with first building's first segment and floor
  const initialBuilding = 'vic-1';
  const initialFloor = floorLayoutList[initialBuilding].floors[0];

  const [selectedBuilding, setSelectedBuilding] = useState(initialBuilding);
  const [selectedFloor, setSelectedFloor] = useState(initialFloor);
  const [showApartmentInfo, setShowApartmentInfo] = useState({
    isOpen: false,
    data: null,
  });
  const [clickedApartment, setClickedApartment] = useState(null);

  const handleChangeBuilding = (buildingId) => {
    if (!buildingId) return;

    setSelectedBuilding(buildingId);
    setSelectedFloor(floorLayoutList[buildingId].floors[0]);
  };

  const handleChangeFloor = (floorId) => {
    if (!floorId) return;
    setSelectedFloor(floorId);
  };

  useEffect(() => {
    return () => {
      setShowApartmentInfo(false);
    };
  }, []);

  return (
    <div className="mat-bang-tang-page">
      {showApartmentInfo.isOpen && (
        <ApartmentInfo
          data={showApartmentInfo.data}
          onBack={() => {
            setClickedApartment(null);
            setShowApartmentInfo({ isOpen: false, data: null });
          }}
        />
      )}

      {!showApartmentInfo.isOpen && (
        <>
          <Filter
            onChangeBuilding={handleChangeBuilding}
            onChangeFloor={handleChangeFloor}
            selectedBuilding={selectedBuilding}
            selectedFloor={selectedFloor}
          />

          <div className="extended-info">
            <div className="disclaimer-card-container">
              <DisclaimerCard />
            </div>
            <FloorPalette />
            <FloorDetail selectedBuilding={selectedBuilding} />
          </div>

          {/* <DropdownMenu className="dropdown-mobile">
            <DropdownMenu.Trigger>
              <InfoCircle />
            </DropdownMenu.Trigger>
            <DropdownMenu.Content align="end" side="bottom" sideOffset={16}>
              <DisclaimerCard />
            </DropdownMenu.Content>
          </DropdownMenu> */}
        </>
      )}

      <FloorPlan
        onShow={(data) => setShowApartmentInfo({ isOpen: true, data })}
        selectedBuilding={selectedBuilding}
        selectedFloor={selectedFloor}
        clickedApartment={clickedApartment}
        setClickedApartment={setClickedApartment}
        isViewingApartmentInfo={showApartmentInfo.isOpen}
      />
    </div>
  );
};

export default MatBangTangPage;
